(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doi-55-buyer"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const hero = root.querySelector('[data-d55-hero]');
    if (!hero) return;
    const heroImage = hero.querySelector('img');
    const thumbnails = [...root.querySelectorAll('[data-d55-thumb]')];
    const strip = root.querySelector('[data-d55-thumbs]');
    const stage = root.querySelector('[data-d55-stage]');
    const inlineCounter = root.querySelector('[data-d55-inline-count]');
    const inlinePrevious = root.querySelector('[data-d55-inline-prev]');
    const inlineNext = root.querySelector('[data-d55-inline-next]');
    const photos = (thumbnails.length ? thumbnails : [hero]).map(link => {
      const image = link.querySelector('img');
      return { full: link.href, src: link.dataset.src || image.src, srcset: link.dataset.srcset || image.srcset, width: Number(link.dataset.width || image.getAttribute('width')) || image.naturalWidth, height: Number(link.dataset.height || image.getAttribute('height')) || image.naturalHeight, alt: image.alt };
    });
    const dialog = root.querySelector('dialog');
    const fullImage = dialog.querySelector('[data-d55-full]');
    const counter = dialog.querySelector('[data-d55-count]');
    const previous = dialog.querySelector('[data-d55-prev]');
    const next = dialog.querySelector('[data-d55-next]');
    let current = 0;
    let lastFocus;
    let originalOverflow;
    let touchStart = null;
    function updateCounter(element) {
      if (element) element.textContent = element.dataset.count.replace('[current]', current + 1).replace('[total]', photos.length);
    }
    function showImage(index, revealThumbnail = true) {
      current = Math.max(0, Math.min(index, photos.length - 1));
      const photo = photos[current];
      hero.href = photo.full;
      hero.setAttribute('aria-label', hero.dataset.enlarge.replace('[number]', current + 1));
      heroImage.width = photo.width;
      heroImage.height = photo.height;
      heroImage.alt = photo.alt;
      heroImage.srcset = photo.srcset;
      heroImage.src = photo.src;
      thumbnails.forEach((thumb, position) => {
        if (position === current) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      if (revealThumbnail && strip && thumbnails[current]) {
        const item = thumbnails[current].getBoundingClientRect();
        const frame = strip.getBoundingClientRect();
        if (item.left < frame.left) strip.scrollLeft += item.left - frame.left;
        else if (item.right > frame.right) strip.scrollLeft += item.right - frame.right;
      }
      if (dialog.open) {
        fullImage.src = photo.full;
        fullImage.alt = photo.alt;
      }
      updateCounter(inlineCounter);
      updateCounter(counter);
      previous.disabled = current === 0;
      next.disabled = current === photos.length - 1;
      if (inlinePrevious) inlinePrevious.disabled = previous.disabled;
      if (inlineNext) inlineNext.disabled = next.disabled;
    }
    thumbnails.forEach((thumb, index) => thumb.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      showImage(index);
    }));
    if (inlinePrevious && inlineNext) {
      inlinePrevious.hidden = false;
      inlineNext.hidden = false;
      inlinePrevious.addEventListener('click', () => showImage(current - 1));
      inlineNext.addEventListener('click', () => showImage(current + 1));
    }
    hero.addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      lastFocus = hero;
      originalOverflow = document.body.style.overflow;
      fullImage.src = photos[current].full;
      fullImage.alt = photos[current].alt;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
    });
    function keyNavigation(event) {
      if (event.key === 'ArrowLeft' && current > 0) { event.preventDefault(); showImage(current - 1); }
      if (event.key === 'ArrowRight' && current < photos.length - 1) { event.preventDefault(); showImage(current + 1); }
    }
    stage.addEventListener('keydown', keyNavigation);
    if (strip) strip.addEventListener('keydown', keyNavigation);
    stage.addEventListener('touchstart', event => {
      touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
    }, { passive: true });
    stage.addEventListener('touchmove', event => { if (event.touches.length !== 1) touchStart = null; }, { passive: true });
    stage.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
    stage.addEventListener('touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) showImage(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    dialog.querySelector('[data-d55-close]').addEventListener('click', () => dialog.close());
    previous.addEventListener('click', () => showImage(current - 1));
    next.addEventListener('click', () => showImage(current + 1));
    dialog.addEventListener('keydown', keyNavigation);
    dialog.addEventListener('close', () => { document.body.style.overflow = originalOverflow || ''; if (lastFocus) lastFocus.focus(); });
    showImage(0, false);
  }
  document.querySelectorAll('[data-doi55]').forEach(init);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-doi55]').forEach(init); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-announcement"]) return;
  try {
    
if (!customElements.get('doi-member-menu')) {
  customElements.define('doi-member-menu', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const listen = (target, type, fn) => target.addEventListener(type, fn, {signal:this.events.signal});
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      const bar = this.closest('[data-mydoi-account-bar]');
      const close = (restore = false) => { details.open = false; summary.setAttribute('aria-expanded','false'); if (restore) summary.focus({preventScroll:true}); };
      summary.setAttribute('aria-expanded',String(details.open));
      listen(details,'toggle',() => summary.setAttribute('aria-expanded',String(details.open)));
      listen(this,'keydown',event => { if (event.key === 'Escape' && details.open) { event.preventDefault(); event.stopPropagation(); close(true); } });
      listen(document,'pointerdown',event => { if (!this.contains(event.target)) close(); });
      listen(document,'focusin',event => { if (!this.contains(event.target)) close(); });
      listen(this,'click',event => { if (event.target.closest('a[href]')) close(); });
      listen(window,'pageshow',() => close());
      const mobile = matchMedia('(max-width:1099px)');
      listen(mobile,'change',() => {
        const active = document.activeElement;
        const owned = this.contains(active);
        const hiddenShortcut = bar.querySelector('.da-shortcuts')?.contains(active) && active.matches('[data-account-shortcut="history"],[data-account-shortcut="foryou"],[data-account-shortcut="tools"]');
        close();
        if (owned || (mobile.matches && hiddenShortcut)) summary.focus({preventScroll:true});
      });
      this.authObserver = new MutationObserver(() => { if (bar.dataset.authenticated !== 'true') { const owned = this.contains(document.activeElement); close(); if (owned) bar.querySelector('.da-guest-profile')?.focus({preventScroll:true}); } });
      this.authObserver.observe(bar,{attributes:true,attributeFilter:['data-authenticated']});
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; this.authObserver?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-artwork"]) return;
  try {
    
if(!customElements.get('doi-artwork'))customElements.define('doi-artwork',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    const dialog=this.querySelector('dialog'),image=dialog.querySelector('[data-viewer-image]'),caption=dialog.querySelector('[data-viewer-caption]');let opener;
    for(const link of this.querySelectorAll('[data-artwork-zoom]'))link.addEventListener('click',event=>{if(typeof dialog.showModal!=='function')return;event.preventDefault();opener=link;const source=link.querySelector('img');image.src=link.href;image.alt=source.alt;image.width=source.naturalWidth||1333;image.height=source.naturalHeight||2000;caption.textContent=source.alt;dialog.showModal();});
    dialog.addEventListener('close',()=>{image.removeAttribute('src');opener?.focus({preventScroll:true});});
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();});
    const gallery=this.querySelector('[data-artwork-films]'),keys=new Set([...gallery.querySelectorAll('[data-film-key]')].map(n=>n.dataset.filmKey));
    for(const iframe of this.querySelectorAll('.doi-artwork__story iframe')){let url;try{url=new URL(iframe.src);}catch{continue;}const host=url.hostname,key=host.endsWith('youtube.com')||host.endsWith('youtube-nocookie.com')?'youtube:'+url.pathname.split('/').pop():host==='player.vimeo.com'?'vimeo:'+url.pathname.split('/').pop():null;if(!key)continue;if(!keys.has(key)){keys.add(key);const details=document.createElement('details'),summary=document.createElement('summary'),template=document.createElement('template'),mount=document.createElement('div');details.dataset.artworkFilm='';summary.textContent=iframe.title||this.dataset.watch;mount.dataset.filmMount='';template.content.append(iframe.cloneNode(true));details.append(summary,template,mount);gallery.append(details);}iframe.remove();}
    const films=[...gallery.querySelectorAll('[data-artwork-film]')];films.forEach(film=>film.addEventListener('toggle',()=>{const mount=film.querySelector('[data-film-mount]');if(!film.open){mount.replaceChildren();return;}films.filter(other=>other!==film).forEach(other=>{other.open=false;other.querySelector('[data-film-mount]').replaceChildren();});mount.replaceChildren(film.querySelector('template').content.cloneNode(true));}));
    this.querySelector('.doi-artwork__films').hidden=films.length===0;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-bird-profile"]) return;
  try {
    
(() => {
  const start = (scope = document) => {
    scope.querySelectorAll('[data-bird-profile]').forEach((root) => {
      if (root.dataset.bpReady) return;
      root.dataset.bpReady = 'true';
      const photos = [...root.querySelectorAll('[data-bp-photo]')];
      const cards = [...root.querySelectorAll('[data-bp-gallery-card]')];
      const more = root.querySelector('[data-bp-more]');
      const dialog = root.querySelector('[data-bp-dialog]');
      let visible = 15;
      const showCards = () => {
        cards.forEach((card, i) => { card.hidden = i >= visible; });
        if (more) more.hidden = visible >= cards.length;
      };
      showCards();
      if (more) more.addEventListener('click', () => {
        const firstNew = cards[visible];
        visible += 16;
        showCards();
        if (firstNew) firstNew.querySelector('a').focus({preventScroll: true});
      });
      if (!dialog || !photos.length || typeof dialog.showModal !== 'function') return;
      const stage = dialog.querySelector('.bp-lightbox-stage');
      stage.classList.toggle('bp-single-photo', photos.length < 2);
      const fullImage = dialog.querySelector('[data-bp-full-image]');
      const caption = dialog.querySelector('[data-bp-caption]');
      const count = dialog.querySelector('[data-bp-count]');
      const prev = dialog.querySelector('[data-bp-prev]');
      const next = dialog.querySelector('[data-bp-next]');
      let current = 0;
      let opener;
      let oldOverflow = '';
      let startX = 0;
      let startY = 0;
      const show = (index) => {
        current = (index + photos.length) % photos.length;
        const photo = photos[current];
        const thumbnail = photo.querySelector('img');
        fullImage.src = photo.href;
        fullImage.alt = thumbnail ? thumbnail.alt : '';
        caption.textContent = photo.dataset.caption || fullImage.alt;
        count.textContent = `${current + 1} / ${photos.length}`;
        prev.hidden = next.hidden = photos.length < 2;
      };
      const open = (index, trigger) => {
        opener = trigger;
        show(index);
        if (!dialog.open) {
          oldOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
      };
      photos.forEach((photo, i) => photo.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(i, photo);
      }));
      root.querySelectorAll('[data-bp-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
        event.preventDefault();
        open(0, trigger);
      }));
      dialog.querySelector('[data-bp-close]').addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      dialog.addEventListener('close', () => {
        document.body.style.overflow = oldOverflow;
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      fullImage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, {passive: true});
      fullImage.addEventListener('touchend', (event) => {
        if (!event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx > 0 ? -1 : 1));
      }, {passive: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-coachella"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-coachella')) {
  customElements.define('doi-coachella', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-coa-card]')];
      const filters = [...this.querySelectorAll('[data-coa-filter]')];
      const search = this.querySelector('[data-coa-search]');
      const more = this.querySelector('[data-coa-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.coaFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-coa-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-coa-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.coaFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-coa-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.coaFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-coa-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-coa-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-coa-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-coa-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-coa-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-coa-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-coa-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-coa-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.coaLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-coa-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-coa-day]')];
        const panels = [...this.querySelectorAll('[data-coa-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.coaPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.coaDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.coaDay)));
        if (choices.length) setDay(choices[0].dataset.coaDay);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initializeContact(root) {
    if (root.dataset.doiReady) return;
    root.dataset.doiReady = 'true';
    const topic = root.querySelector('[data-doi-topic]');
    if (topic) {
      const requestedTopic = new URLSearchParams(location.search).get('topic');
      const requestedOption = Array.from(topic.options).find(option => option.dataset.topicKey === requestedTopic);
      if (requestedOption && topic.selectedOptions[0]?.dataset.topicKey === 'general' && !root.querySelector('.doi-contact__status--error')) topic.value = requestedOption.value;
      const updateHint = () => {
        const key = topic.selectedOptions[0].dataset.topicKey;
        root.querySelectorAll('[data-doi-hint]').forEach(hint => {
          hint.hidden = hint.dataset.doiHint !== key;
        });
      };
      topic.addEventListener('change', updateHint);
      updateHint();
      window.addEventListener('pageshow', updateHint);
    }
    const status = root.querySelector('[data-doi-contact-status]');
    if (status) status.focus();
  }
  function initializeAll() {
    document.querySelectorAll('[data-doi-contact]').forEach(initializeContact);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-cotino-floor-plan"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const dialog=root.querySelector('dialog'),large=dialog.querySelector('[data-cfp-large]'),viewer=dialog.querySelector('.cfp__viewer'),zoom=dialog.querySelector('[data-cfp-zoom]');
    let current=[],index=0,returnFocus=null,previousOverflow='';
    function render(){const a=current[index];large.src=a.href;large.alt=a.dataset.cfpAlt||'';dialog.querySelector('[data-cfp-caption]').textContent=large.alt;dialog.querySelector('[data-cfp-counter]').textContent=(index+1)+' / '+current.length;dialog.querySelector('[data-cfp-prev]').hidden=current.length<2;dialog.querySelector('[data-cfp-next]').hidden=current.length<2;viewer.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');viewer.scrollTop=0;viewer.scrollLeft=0;}
    root.addEventListener('click',e=>{const a=e.target.closest('[data-cfp-open]');if(!a)return;e.preventDefault();returnFocus=a;const group=a.dataset.cfpGroup;current=Array.from(root.querySelectorAll(group==='photos'?'[data-cfp-gallery]':'[data-cfp-group="drawings"]'));index=Math.max(0,current.findIndex(item=>item.href===a.href));render();previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();});
    function move(delta){index=(index+delta+current.length)%current.length;render();}
    dialog.querySelector('[data-cfp-prev]').addEventListener('click',()=>move(-1));dialog.querySelector('[data-cfp-next]').addEventListener('click',()=>move(1));
    dialog.querySelector('[data-cfp-close]').addEventListener('click',()=>dialog.close());
    zoom.addEventListener('click',()=>{const active=viewer.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));});
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();move(1);}if(e.key==='ArrowLeft'){e.preventDefault();move(-1);}});
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;returnFocus?.focus({preventScroll:true});});
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
  }
  document.querySelectorAll('[data-cfp]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-cfp]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-cotino-place"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.cpReady) return;
    root.dataset.cpReady='true';
    const more=root.querySelector('[data-cp-more]');
    more?.addEventListener('click',()=>{const expanded=more.getAttribute('aria-expanded')==='true';root.querySelectorAll('[data-cp-extra]').forEach(item=>item.hidden=expanded);more.setAttribute('aria-expanded',String(!expanded));more.querySelector('.cp__more-arrow').style.transform=expanded?'rotate(0deg)':'rotate(180deg)';});
    const links=Array.from(root.querySelectorAll('[data-cp-image]'));
    const dialog=root.querySelector('dialog'),large=dialog.querySelector('[data-cp-large]'),viewer=dialog.querySelector('.cp__viewer'),zoom=dialog.querySelector('[data-cp-zoom]');
    let index=0,returnFocus=null,previousOverflow='';
    function show(){const item=links[index];large.src=item.href;large.alt=item.dataset.cpAlt||'';dialog.querySelector('[data-cp-caption]').textContent=large.alt;dialog.querySelector('[data-cp-counter]').textContent=(index+1)+' / '+links.length;dialog.querySelector('[data-cp-prev]').hidden=links.length<2;dialog.querySelector('[data-cp-next]').hidden=links.length<2;viewer.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');viewer.scrollTop=0;viewer.scrollLeft=0;}
    function move(delta){index=(index+delta+links.length)%links.length;show();}
    root.addEventListener('click',event=>{const item=event.target.closest('[data-cp-image]');if(!item)return;event.preventDefault();returnFocus=item;index=links.indexOf(item);show();previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();});
    dialog.querySelector('[data-cp-prev]').addEventListener('click',()=>move(-1));
    dialog.querySelector('[data-cp-next]').addEventListener('click',()=>move(1));
    dialog.querySelector('[data-cp-close]').addEventListener('click',()=>dialog.close());
    zoom.addEventListener('click',()=>{const active=viewer.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(active));});
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();move(1)}if(event.key==='ArrowLeft'){event.preventDefault();move(-1)}});
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;returnFocus?.focus({preventScroll:true});});
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  }
  document.querySelectorAll('[data-cotino-place]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cotino-place]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-cotino-resource-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-cdr]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready='true';
      const input=root.querySelector('[data-cdr-search]'),clear=root.querySelector('[data-cdr-clear]'),more=root.querySelector('[data-cdr-more]'),status=root.querySelector('[data-cdr-status]'),empty=root.querySelector('.cdr__empty');
      const buttons=[...root.querySelectorAll('[data-cdr-filter]')],items=[...root.querySelectorAll('[data-cdr-item]')];
      const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      const texts=new Map(items.map(item=>[item,normalize(item.textContent)]));
      let category='all',limit=9;
      function update(restore=false) {
        const terms=normalize(input.value.trim()).split(/\s+/).filter(Boolean);
        const matches=items.filter(item=>(category==='all'||item.dataset.category===category)&&terms.every(term=>texts.get(item).includes(term)));
        const visible=new Set(matches.slice(0,limit));
        items.forEach(item=>{item.hidden=!visible.has(item);});
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.cdrFilter===category)));
        status.textContent=status.dataset.format.replace('__SHOWN__',String(visible.size)).replace('__TOTAL__',String(matches.length));
        clear.hidden=!input.value;
        more.hidden=matches.length<=limit;
        empty.hidden=matches.length>0;
        if(restore&&more.hidden) (matches[limit-9]?.querySelector('a')||matches[0]?.querySelector('a')||input).focus({preventScroll:true});
      }
      input.addEventListener('input',()=>{limit=9;update();});
      clear.addEventListener('click',()=>{input.value='';limit=9;update();input.focus();});
      buttons.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.cdrFilter;limit=9;update();}));
      more.addEventListener('click',()=>{limit+=9;update(true);});
      root.querySelector('.cdr__controls').hidden=false;
      update();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-flora-profile"]) return;
  try {
    
(() => {
  const start = (scope = document) => {
    scope.querySelectorAll('[data-flora-profile]').forEach((root) => {
      if (root.dataset.fpReady) return;
      root.dataset.fpReady = 'true';
      const photos = [...root.querySelectorAll('[data-fp-photo]')];
      const cards = [...root.querySelectorAll('[data-fp-gallery-card]')];
      const more = root.querySelector('[data-fp-more]');
      const dialog = root.querySelector('[data-fp-dialog]');
      let visible = 15;
      const showCards = () => {
        cards.forEach((card, i) => { card.hidden = i >= visible; });
        if (more) more.hidden = visible >= cards.length;
      };
      showCards();
      if (more) more.addEventListener('click', () => {
        const firstNew = cards[visible];
        visible += 16;
        showCards();
        if (firstNew) firstNew.querySelector('a').focus({preventScroll: true});
      });
      if (!dialog || !photos.length || typeof dialog.showModal !== 'function') return;
      const fullImage = dialog.querySelector('[data-fp-full-image]');
      const caption = dialog.querySelector('[data-fp-caption]');
      const count = dialog.querySelector('[data-fp-count]');
      const prev = dialog.querySelector('[data-fp-prev]');
      const next = dialog.querySelector('[data-fp-next]');
      let current = 0;
      let opener;
      let oldOverflow = '';
      let startX = 0;
      let startY = 0;
      const show = (index) => {
        current = (index + photos.length) % photos.length;
        const photo = photos[current];
        const thumbnail = photo.querySelector('img');
        fullImage.src = photo.href;
        fullImage.alt = thumbnail ? thumbnail.alt : '';
        caption.textContent = photo.dataset.caption || fullImage.alt;
        count.textContent = `${current + 1} / ${photos.length}`;
        prev.hidden = next.hidden = photos.length < 2;
      };
      const open = (index, trigger) => {
        opener = trigger;
        show(index);
        if (!dialog.open) {
          oldOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
      };
      photos.forEach((photo, i) => photo.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(i, photo);
      }));
      root.querySelectorAll('[data-fp-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
        event.preventDefault();
        open(0, trigger);
      }));
      dialog.querySelector('[data-fp-close]').addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      dialog.addEventListener('close', () => {
        document.body.style.overflow = oldOverflow;
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      fullImage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, {passive: true});
      fullImage.addEventListener('touchend', (event) => {
        if (!event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx > 0 ? -1 : 1));
      }, {passive: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-footer')) {
  customElements.define('doi-footer', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.groups = [...this.querySelectorAll('.df__group')];
      this.mobile = matchMedia('(max-width: 700px)');
      this.syncGroups = () => {
        this.groups.forEach(group => {
          const summary = group.querySelector('summary');
          if (this.mobile.matches && group.contains(document.activeElement)) summary.focus();
          group.open = !this.mobile.matches;
          if (this.mobile.matches) summary.removeAttribute('tabindex');
          else summary.setAttribute('tabindex', '-1');
        });
      };
      this.syncGroups();
      this.classList.add('is-enhanced');
      this.mobile.addEventListener('change', this.syncGroups, options);
      this.groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (!this.mobile.matches) event.preventDefault();
      }, options));
      this.querySelector('[data-back-top]').addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        const destination = document.querySelector('doi-navigation .dn-brand') || document.querySelector('a[href="#MainContent"]');
        if (destination) destination.focus({ preventScroll: true });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-golf-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.dgReady) return;
    root.dataset.dgReady = 'true';
    const select = root.querySelector('[data-dg-select]');
    const rows = [...root.querySelectorAll('[data-dg-tee]')];
    const selectTee = (name) => {
      const row = rows.find((item) => item.dataset.dgTee === name);
      if (!row || !select) return;
      select.value = name;
      root.querySelector('[data-dg-yardage]').textContent = row.dataset.yards;
      root.querySelector('[data-dg-tee-label]').textContent = name;
      rows.forEach((item) => {
        const active = item === row;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      try { localStorage.setItem('doi-trilogy-tee', name); } catch (_) {}
    };
    if (select) {
      select.addEventListener('change', () => selectTee(select.value));
      rows.forEach((row) => row.addEventListener('click', () => selectTee(row.dataset.dgTee)));
      try { selectTee(localStorage.getItem('doi-trilogy-tee') || 'Gold'); } catch (_) { selectTee('Gold'); }
    }
    const thumbs = [...root.querySelectorAll('[data-dg-thumb]')];
    const opener = root.querySelector('[data-dg-open]');
    const dialog = root.querySelector('.dg-dialog');
    if (!thumbs.length || !opener || !dialog) return;
    const main = root.querySelector('.dg-main-image');
    const full = root.querySelector('.dg-full-image');
    const counter = root.querySelector('[data-dg-count]');
    const modalCounter = root.querySelector('[data-dg-modal-count]');
    const steps = [...root.querySelectorAll('[data-dg-step]')];
    const close = root.querySelector('[data-dg-close]');
    let index = 0;
    let previousFocus;
    let previousOverflow;
    let pointerStart;
    const countText = () => root.dataset.photoTemplate.replace('DG_INDEX', String(index + 1)).replace('DG_COUNT', String(thumbs.length));
    const render = (next, changeMain = true) => {
      index = (next + thumbs.length) % thumbs.length;
      const thumbnail = thumbs[index];
      if (changeMain) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = thumbnail.dataset.src;
        main.alt = thumbnail.dataset.alt;
        opener.style.setProperty('--dg-photo-ratio', thumbnail.dataset.ratio || '1.5');
      }
      opener.href = thumbnail.dataset.full;
      counter.textContent = countText();
      modalCounter.textContent = countText();
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      steps.forEach((step) => { step.disabled = thumbs.length < 2; });
      if (dialog.open) {
        full.src = thumbnail.dataset.full;
        full.alt = thumbnail.dataset.alt;
      }
    };
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => render(i)));
    opener.addEventListener('click', (event) => {
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      render(index, false);
      close.focus();
    });
    const closeGallery = () => { if (dialog.open) dialog.close(); };
    close.addEventListener('click', closeGallery);
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow || '';
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
    });
    steps.forEach((step) => step.addEventListener('click', () => render(index + Number(step.dataset.dgStep))));
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        render(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    full.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'touch' && event.isPrimary) pointerStart = {x:event.clientX,y:event.clientY};
    });
    full.addEventListener('pointerup', (event) => {
      if (!pointerStart) return;
      const dx = event.clientX - pointerStart.x;
      const dy = event.clientY - pointerStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) render(index + (dx < 0 ? 1 : -1));
      pointerStart = null;
    });
    full.addEventListener('pointercancel', () => { pointerStart = null; });
    render(0, false);
  };
  const initializeAll = () => document.querySelectorAll('[data-dg-root]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, {once:true});
  else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-hiking-trail"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-ht-photo]');
  if (link) {
    const article = link.closest('[data-hiking-trail]');
    const dialog = article && article.querySelector('.ht-lightbox');
    if (!dialog || !dialog.showModal) return;
    event.preventDefault();
    const links = Array.from(article.querySelectorAll('[data-ht-photo]'));
    dialog.dataset.photoIndex = String(links.indexOf(link));
    const image = dialog.querySelector('img');
    image.src = link.href;
    image.alt = link.dataset.caption || '';
    dialog.querySelector('.ht-lightbox-caption').textContent = link.dataset.caption || '';
    dialog.querySelector('[data-ht-prev]').hidden = links.length < 2;
    dialog.querySelector('[data-ht-next]').hidden = links.length < 2;
    dialog.showModal();
    return;
  }
  const control = event.target.closest('[data-ht-close], [data-ht-prev], [data-ht-next]');
  if (!control) {
    if (event.target.matches('.ht-lightbox')) event.target.close();
    return;
  }
  const dialog = control.closest('.ht-lightbox');
  if (control.matches('[data-ht-close]')) { dialog.close(); return; }
  const links = Array.from(dialog.closest('[data-hiking-trail]').querySelectorAll('[data-ht-photo]'));
  if (!links.length) return;
  const step = control.matches('[data-ht-next]') ? 1 : -1;
  const index = (Number(dialog.dataset.photoIndex) + step + links.length) % links.length;
  const nextLink = links[index];
  dialog.dataset.photoIndex = String(index);
  const image = dialog.querySelector('img');
  image.src = nextLink.href;
  image.alt = nextLink.dataset.caption || '';
  dialog.querySelector('.ht-lightbox-caption').textContent = nextLink.dataset.caption || '';
});
document.addEventListener('keydown', function (event) {
  if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
  const dialog = document.querySelector('.ht-lightbox[open]');
  if (!dialog) return;
  event.preventDefault();
  dialog.querySelector(event.key === 'ArrowRight' ? '[data-ht-next]' : '[data-ht-prev]').click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-idyllwild"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-idyllwild')) {
  customElements.define('doi-idyllwild', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-idy-card]')];
      const filters = [...this.querySelectorAll('[data-idy-filter]')];
      const search = this.querySelector('[data-idy-search]');
      const more = this.querySelector('[data-idy-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.idyFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-idy-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-idy-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.idyFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-idy-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.idyFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-idy-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-idy-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-idy-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-idy-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-idy-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-idy-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-idy-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-idy-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.idyLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-idy-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-idy-day]')];
        const panels = [...this.querySelectorAll('[data-idy-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.idyPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.idyDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.idyDay)));
        if (choices.length) setDay(choices[0].dataset.idyDay);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-indian-wells"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-indian-wells')) {
  customElements.define('doi-indian-wells', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-iw-card]')];
      const filters = [...this.querySelectorAll('[data-iw-filter]')];
      const search = this.querySelector('[data-iw-search]');
      const more = this.querySelector('[data-iw-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.iwFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-iw-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-iw-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.iwFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-iw-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.iwFilter; limit = 16; applyFilters(); }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-iw-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-iw-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-iw-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-iw-map]');
          frame.src = 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=' + (option.value === 'overview' ? 13 : 16) + '&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-iw-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-iw-directions]').href = 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-iw-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.iwLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-iw-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-iw-day]')];
        const panels = [...this.querySelectorAll('[data-iw-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.iwPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.iwDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.iwDay)));
        setDay('golf');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-indio"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-indio')) {
  customElements.define('doi-indio', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-ind-card]')];
      const filters = [...this.querySelectorAll('[data-ind-filter]')];
      const search = this.querySelector('[data-ind-search]');
      const more = this.querySelector('[data-ind-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.indFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-ind-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-ind-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.indFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-ind-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.indFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-ind-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const nativePlaces = {"trilogy-polo-club":"trilogy-polo-club","empire-polo-club":"atlas-274488099097","eldorado-polo-club":"atlas-274488164633","riverside-county-fair-national-date-festival":"atlas-274488262937","shields-date-garden":"p22","coachella-valley-horse-rescue":"atlas-274488557849","four-seasons-at-terra-lago":"four-seasons-at-terra-lago","indio-hills-badlands-indio-california":"atlas-274488983833","worldmark-indio":"atlas-274489278745","indian-palms-country-club":"indian-palms-country-club","sun-city-shadow-hills-phase-3-golf-course-north-course":"sun-city-shadow-hills","sun-city-shadow-hills-ca":"sun-city-shadow-hills","shadow-lake-estates":"shadow-lake-estates","desert-retreat-indio-ca":"desert-retreat","coachella-music-arts-festival":"atlas-306509349145"};
      this.querySelectorAll('[data-ind-locate]').forEach(button => {
        const place = nativePlaces[button.dataset.indLocate];
        if (!place) return;
        button.hidden = false;
        on(button, 'click', () => {
          const url = new URL('/pages/coachella-valley-interactive-map', window.location.origin);
          url.searchParams.set('city', 'city-indio-california');
          url.searchParams.set('from', window.location.pathname);
          const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.hash = 'place=' + encodeURIComponent(place);
          window.location.assign(url.href);
        });
      });
      const dayControls = this.querySelector('[data-ind-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-ind-day]')];
        const panels = [...this.querySelectorAll('[data-ind-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.indPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.indDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.indDay)));
        setDay('culture');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-la-quinta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-la-quinta')) {
  customElements.define('doi-la-quinta', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-lq-card]')];
      const filters = [...this.querySelectorAll('[data-lq-filter]')];
      const search = this.querySelector('[data-lq-search]');
      const more = this.querySelector('[data-lq-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.lqFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-lq-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-lq-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lqFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-lq-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.lqFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-lq-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-lq-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-lq-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-lq-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-lq-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-lq-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-lq-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-lq-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.lqLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-lq-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-lq-day]')];
        const panels = [...this.querySelectorAll('[data-lq-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.lqPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lqDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.lqDay)));
        setDay('culture');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-legends-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('doi-legend-directory'))customElements.define('doi-legend-directory',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  const grid=this.querySelector('.lc-card-grid'),cards=[...grid.querySelectorAll('[data-lc-card]')],search=this.querySelector('input[type=search]'),sort=this.querySelector('select'),filters=[...this.querySelectorAll('[data-lc-filter]')],results=this.querySelector('[data-lc-results]'),more=this.querySelector('[data-lc-more]'),reset=this.querySelector('[data-lc-reset]'),empty=this.querySelector('.lc-empty');let topic='all',limit=16;
  const norm=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const format=(s,values)=>s.replace(/\[(shown|total|next)\]/g,(_,k)=>values[k]);
  const draw=(focusNew=false)=>{const q=norm(search.value),ordered=[...cards];if(sort.value==='az')ordered.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));ordered.forEach(c=>grid.append(c));const matches=ordered.filter(c=>(topic==='all'||c.dataset.topic.split(' ').includes(topic))&&norm(c.dataset.search).includes(q));const shown=Math.min(limit,matches.length),next=Math.min(16,matches.length-shown);cards.forEach(c=>c.hidden=true);matches.slice(0,shown).forEach(c=>c.hidden=false);filters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.lcFilter===topic)));results.textContent=format(results.dataset.format,{shown,total:matches.length});more.hidden=shown>=matches.length;more.textContent=format(more.dataset.format,{shown,total:matches.length,next});reset.hidden=!q&&topic==='all'&&sort.value==='curated';empty.hidden=matches.length!==0;if(focusNew)matches[Math.max(0,limit-16)]?.querySelector('a')?.focus({preventScroll:true});};
  this.querySelector('[data-lc-tools]').hidden=false;
  search.addEventListener('input',()=>{limit=16;draw();},{signal});sort.addEventListener('change',()=>{limit=16;draw();},{signal});filters.forEach(b=>b.addEventListener('click',()=>{topic=b.dataset.lcFilter;limit=16;draw();},{signal}));more.addEventListener('click',()=>{limit+=16;draw(true);},{signal});const resetAll=()=>{search.value='';sort.value='curated';topic='all';limit=16;draw();search.focus({preventScroll:true});};reset.addEventListener('click',resetAll,{signal});this.querySelector('[data-lc-empty-reset]').addEventListener('click',resetAll,{signal});draw();
 }
 disconnectedCallback(){this.abort?.abort();this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-legends"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('doi-legends'))customElements.define('doi-legends',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;this.initialized=true;this.abort=new AbortController();const signal=this.abort.signal;
  const prose=this.querySelector('.lg-prose'),toc=this.querySelector('.lg-toc'),list=toc.querySelector('ol');
  const headings=[...prose.querySelectorAll('h2,h3')];
  headings.forEach((h,i)=>{h.id=h.id||this.id+'-chapter-'+(i+1);const li=document.createElement('li'),a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent.trim();li.append(a);list.append(li);});toc.hidden=!headings.length;
  const links=[...list.querySelectorAll('a')],progress=this.querySelector('.lg-progress span');let pending=false;
  const update=()=>{pending=false;const box=prose.getBoundingClientRect(),available=Math.max(1,box.height-innerHeight+150);progress.style.transform='scaleX('+Math.max(0,Math.min(1,(150-box.top)/available))+')';let active=-1;headings.forEach((h,i)=>{if(h.getBoundingClientRect().top<innerHeight*.4)active=i;});links.forEach((a,i)=>{if(i===active)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});};
  addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true,signal});addEventListener('resize',update,{passive:true,signal});update();
  const dialog=this.querySelector('.lg-lightbox'),mount=dialog.querySelector('.lg-lightbox-image');let opener=null;
  this.querySelectorAll('[data-lg-image]').forEach(a=>a.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();opener=a;const img=document.createElement('img');img.src=a.href;img.alt=a.querySelector('img')?.alt||'';mount.replaceChildren(img);dialog.showModal();},{signal}));
  dialog.querySelector('button').addEventListener('click',()=>dialog.close(),{signal});dialog.addEventListener('close',()=>{mount.replaceChildren();opener?.focus({preventScroll:true});},{signal});
  const video=this.querySelector('.lg-series-video');video?.addEventListener('toggle',()=>{const slot=video.querySelector('[data-lg-video]');if(video.open&&!slot.firstChild){const iframe=document.createElement('iframe');iframe.src=slot.dataset.lgVideo;iframe.title=slot.dataset.lgVideoTitle;iframe.allow='accelerometer; encrypted-media; gyroscope; picture-in-picture';iframe.allowFullscreen=true;slot.append(iframe);}else if(!video.open)slot.replaceChildren();},{signal});
 }
 disconnectedCallback(){this.abort?.abort();this.initialized=false;this.querySelector('.lg-toc ol')?.replaceChildren();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-lodging"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=async root=>{
if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
const $=s=>root.querySelector(s), $$=s=>[...root.querySelectorAll(s)];
const labels=Object.fromEntries(Object.entries(JSON.parse($('[data-hg-labels]').dataset.hgLabels)).map(([k,v])=>[k,new DOMParser().parseFromString(v,'text/html').body.textContent])), fmt=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',v),labels[key]||key);
const status=$('[data-hg-load-status]'), grid=$('[data-hg-grid]');let pagination=$('[data-hg-pagination]'),next=pagination.dataset.next;const seen=new Set();
if(next)status.textContent=fmt('loading');
try{while(next&&!seen.has(next)){seen.add(next);const url=new URL(next,location.href),current=new URL(location.href);for(const key of ['view','preview_theme_id'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));url.searchParams.set('section_id',root.dataset.hgSection);const response=await fetch(url);if(!response.ok)throw Error('page');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const section=doc.querySelector('#doi-hotels');if(!section)throw Error('section');const known=new Set([...grid.children].map(c=>JSON.parse(c.dataset.hgRecord).handle));section.querySelectorAll('[data-hg-record]').forEach(c=>{if(!known.has(JSON.parse(c.dataset.hgRecord).handle))grid.append(c)});next=section.querySelector('[data-hg-pagination]')?.dataset.next||'';}pagination.hidden=true;status.textContent='';}catch(e){status.textContent=fmt('load_error');if(next){const link=pagination.querySelector('a');if(link)link.href=next;}}
const cards=$$('[data-hg-record]').map(el=>({el,data:JSON.parse(el.dataset.hgRecord)}));
const norm=v=>String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
$$('[data-hg-filter]').forEach(select=>{const key=select.dataset.hgFilter;[...new Set(cards.flatMap(c=>c.data[key]||[]))].sort().forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=value;select.append(option)})});
[...new Set(cards.flatMap(c=>c.data.amenities||[]))].sort().forEach(value=>{const label=document.createElement('label'),input=document.createElement('input');input.type='checkbox';input.value=value;label.append(input,document.createTextNode(value));$('[data-hg-amenities]').append(label)});
let limit=18;const selected=new Set();
function render(){const term=norm($('[data-hg-search]').value),features=$$('[data-hg-amenities] input:checked').map(x=>x.value),sort=$('[data-hg-sort]').value;const ordered=[...cards].sort((a,b)=>sort==='editorial'?(Number(a.data.order)-Number(b.data.order)):String(a.data[sort]||'').localeCompare(String(b.data[sort]||'')));let matched=0;const matches=[];ordered.forEach(c=>{const ok=(!term||norm([c.data.name,c.data.city,c.data.summary,...(c.data.amenities||[])].join(' ')).includes(term))&&$$('[data-hg-filter]').every(s=>!s.value||(Array.isArray(c.data[s.dataset.hgFilter])?c.data[s.dataset.hgFilter].includes(s.value):c.data[s.dataset.hgFilter]===s.value))&&features.every(f=>(c.data.amenities||[]).includes(f));c.el.hidden=!ok||matched>=limit;if(ok){matched++;matches.push(c.el)}grid.append(c.el)});$('[data-hg-count]').textContent=fmt('count',{shown:root.dataset.directoryView==='map'?matched:Math.min(matched,limit),total:cards.length});const extra=features.length+($('[data-hg-filter=property_type]').value?1:0);$('[data-hg-filter-count]').textContent=extra?' ('+extra+')':'';$('[data-hg-empty]').hidden=matched!==0;const more=$('[data-hg-more]');more.hidden=matched<=limit;more.textContent=fmt('load_more',{more:Math.min(18,matched-limit),total:matched});root.doiLodgingMatches=matches;root.doiLodgingComplete=!next;root.dispatchEvent(new CustomEvent('doi:lodging-results',{detail:{cards:matches,complete:!next}}));}
root.addEventListener('doi:lodging-reveal',()=>{limit=cards.length;render()});root.addEventListener('doi:lodging-view',render);
$('[data-hg-tools]').hidden=false;$$('[data-hg-filter], [data-hg-sort], [data-hg-amenities] input').forEach(el=>el.addEventListener('change',()=>{limit=18;render()}));$('[data-hg-search]').addEventListener('input',()=>{limit=18;render()});$$('[data-hg-reset]').forEach(b=>b.addEventListener('click',()=>{$('[data-hg-search]').value='';$$('[data-hg-filter]').forEach(s=>s.value='');$$('[data-hg-amenities] input').forEach(i=>i.checked=false);$('[data-hg-sort]').value='editorial';limit=18;render();$('[data-hg-search]').focus()}));$('[data-hg-more]').addEventListener('click',()=>{limit+=18;render()});
function syncSelection(){cards.forEach(c=>{const b=c.el.querySelector('[data-hg-compare]'),active=selected.has(c.data.handle);b.setAttribute('aria-pressed',String(active));b.textContent=fmt(active?'remove_compare':'add_compare')});$('[data-hg-tray]').hidden=!selected.size;$('[data-hg-selection]').textContent=fmt('selected',{count:selected.size});$('[data-hg-open-compare]').disabled=selected.size<2;root.dispatchEvent(new CustomEvent('doi:lodging-selection',{detail:{ids:[...selected]}}));}
cards.forEach(c=>{const b=c.el.querySelector('[data-hg-compare]');b.hidden=false;b.addEventListener('click',()=>{if(selected.has(c.data.handle))selected.delete(c.data.handle);else if(selected.size<3)selected.add(c.data.handle);else{status.textContent=fmt('select_limit');return}status.textContent='';syncSelection()})});$('[data-hg-clear]').addEventListener('click',()=>{selected.clear();syncSelection();$('[data-hg-search]').focus()});
let dialogLauncher=null;
function openDialog(dialog,launcher){dialogLauncher=launcher;dialog.showModal();dialog.querySelector('[data-hg-close]')?.focus()}
$$('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{if(dialogLauncher?.isConnected)dialogLauncher.focus()}));
$('[data-hg-open-compare]').addEventListener('click',e=>{
 const container=$('[data-hg-comparison]');container.replaceChildren();
 const picks=cards.filter(c=>selected.has(c.data.handle)).map(c=>c.data);
 const scroll=document.createElement('div');scroll.className='hg-compare-scroll';scroll.tabIndex=0;scroll.setAttribute('role','region');scroll.setAttribute('aria-label',fmt('compare_heading'));
 const table=document.createElement('table');const head=document.createElement('thead'),headrow=document.createElement('tr'),corner=document.createElement('th');corner.scope='col';corner.textContent=fmt('details');headrow.append(corner);
 picks.forEach(d=>{const th=document.createElement('th');th.scope='col';th.textContent=d.name;headrow.append(th)});head.append(headrow);table.append(head);
 const body=document.createElement('tbody');
 const rows=[['city','city'],['compare_setting','summary'],['trip','traveler_fit'],['pool','pool_notes'],['golf','golf_notes'],['dining','dining_notes'],['transport','getting_around'],['tradeoffs','tradeoffs'],['positioning','positioning']];
 rows.forEach(([label,key])=>{const tr=document.createElement('tr'),th=document.createElement('th');th.scope='row';th.textContent=fmt(label);tr.append(th);picks.forEach(d=>{const td=document.createElement('td'),v=d[key];td.textContent=Array.isArray(v)?v.join(', '):v||fmt('not_verified');tr.append(td)});body.append(tr)});table.append(body);scroll.append(table);container.append(scroll);
 const notes=document.createElement('div');notes.className='hg-comparison-notes';
 picks.forEach(d=>{const article=document.createElement('article'),title=document.createElement('h3');title.textContent=d.name;article.append(title);const details=document.createElement('details'),summary=document.createElement('summary'),dl=document.createElement('dl');summary.textContent=fmt('more_compare');[['age','age_policy'],['pets','pet_policy'],['accessibility','accessibility_notes']].forEach(([label,key])=>{if(!d[key])return;const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=fmt(label);dd.textContent=d[key];dl.append(dt,dd)});details.append(summary,dl);article.append(details);const link=document.createElement('a');link.href=d.url||d.official_website;link.textContent=d.url?fmt('doi_story'):fmt('official');if(!d.url){link.target='_blank';link.rel='noopener'}article.append(link);notes.append(article)});container.append(notes);openDialog($('[data-hg-dialog]'),e.currentTarget);
});
$$('[data-hg-close]').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));$$('[data-hg-photo]').forEach(b=>b.addEventListener('click',()=>{const dialog=$('[data-hg-lightbox]'),img=dialog.querySelector('img');img.src=b.dataset.hgPhoto;img.alt=b.querySelector('img')?.alt||'';openDialog(dialog,b)}));
render();syncSelection();
};document.querySelectorAll('#doi-hotels').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('#doi-hotels')));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-mark-profile"] && !Shopify.designMode) return;
  try {
    
(()=>{
 function init(){
  const root=document.getElementById('doi-mark-profile');
  if(!root||root.dataset.initialized==='true')return;
  root.dataset.initialized='true';
  const states=JSON.parse(root.querySelector('[data-profile-config]').textContent);
  const decode=value=>{const box=document.createElement('textarea');box.innerHTML=value;return box.value;};
  for(const state of Object.values(states))for(const key of Object.keys(state)){
   if(typeof state[key]==='string')state[key]=decode(state[key]);
   else if(Array.isArray(state[key]))state[key]=state[key].map(decode);
  }
  const tabs=[...root.querySelectorAll('[data-service]')];
  function select(tab){
   const state=states[tab.dataset.service];
   tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
   root.querySelector('#mp-service-panel').setAttribute('aria-labelledby',tab.id);
   root.querySelector('#mp-service-heading').textContent=state.heading;
   root.querySelector('#mp-service-copy').textContent=state.copy;
   root.querySelectorAll('#mp-service-list span').forEach((e,i)=>e.textContent=state.items[i]);
   const contact=root.querySelector('#mp-service-contact');contact.textContent=state.contact;contact.href=state.page;contact.target='_blank';contact.rel='noopener noreferrer';
   const resource=root.querySelector('#mp-service-resource');resource.textContent=state.resource;resource.href=state.url;
  }
  tabs.forEach((tab,i)=>{
   tab.addEventListener('click',()=>select(tab));
   tab.addEventListener('keydown',e=>{
    let next;
    if(e.key==='ArrowRight')next=(i+1)%tabs.length;
    if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;
    if(e.key==='Home')next=0;
    if(e.key==='End')next=tabs.length-1;
    if(next!==undefined){e.preventDefault();tabs[next].focus();select(tabs[next]);}
   });
  });
  select(tabs[0]);
  root.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',e=>{
   const target=root.querySelector(link.getAttribute('href'));
   if(!target)return;e.preventDefault();
   if(target.tagName==='DETAILS')target.open=true;
   target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }));
  const dialog=root.querySelector('#mp-video-dialog');
  const screen=root.querySelector('[data-video-screen]');
  let trigger=null;
  root.querySelectorAll('[data-video]').forEach(link=>link.addEventListener('click',e=>{
   if(typeof dialog.showModal!=='function')return;
   const id=link.dataset.video;if(!/^[A-Za-z0-9_-]{11}$/.test(id))return;
   e.preventDefault();e.stopImmediatePropagation();trigger=link;
   const iframe=document.createElement('iframe');iframe.title=link.getAttribute('aria-label')||link.textContent.trim();
   iframe.src='https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0';
   iframe.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';
   screen.replaceChildren(iframe);if(!dialog.open)dialog.showModal();
  },{capture:true}));
  root.querySelector('[data-video-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',e=>{const b=dialog.getBoundingClientRect();if(e.target===dialog&&(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom))dialog.close();});
  dialog.addEventListener('close',()=>{screen.replaceChildren();if(trigger)trigger.focus();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-palm-desert"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-palm-desert')) {
  customElements.define('doi-palm-desert', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-pd-card]')];
      const filters = [...this.querySelectorAll('[data-pd-filter]')];
      const search = this.querySelector('[data-pd-search]');
      const more = this.querySelector('[data-pd-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.pdFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-pd-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-pd-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pdFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-pd-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.pdFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-pd-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-pd-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-pd-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-pd-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-pd-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-pd-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-pd-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-pd-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.pdLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-pd-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-pd-day]')];
        const panels = [...this.querySelectorAll('[data-pd-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.pdPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.pdDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.pdDay)));
        setDay('culture');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-palm-springs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-palm-springs')) {
  customElements.define('doi-palm-springs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-ps-card]')];
      const filters = [...this.querySelectorAll('[data-ps-filter]')];
      const search = this.querySelector('[data-ps-search]');
      const more = this.querySelector('[data-ps-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.psFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-ps-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-ps-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.psFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-ps-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.psFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-ps-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-ps-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-ps-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-ps-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-ps-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-ps-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-ps-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-ps-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.psLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-ps-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-ps-day]')];
        const panels = [...this.querySelectorAll('[data-ps-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.psPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.psDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.psDay)));
        if (choices.length) setDay(choices[0].dataset.psDay);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-pickleball-hub"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=root=>{if(root.dataset.pbReady)return;root.dataset.pbReady='true';const search=root.querySelector('[data-pb-search]'),city=root.querySelector('select[data-pb-city]'),access=root.querySelector('select[data-pb-access]'),tabs=[...root.querySelectorAll('[data-pb-filter]')],groups=[...root.querySelectorAll('[data-pb-group]')],clear=root.querySelector('[data-pb-clear]'),result=root.querySelector('[data-pb-results]'),empty=root.querySelector('[data-pb-empty]');let active='all';const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();const entries=groups.map(el=>({el,type:el.dataset.pbGroup,step:Number(el.dataset.pbLimit),limit:Number(el.dataset.pbLimit),cards:[...el.querySelectorAll('[data-pb-card]')],more:el.querySelector('[data-pb-more]')}));root.querySelectorAll('.pb-enhanced').forEach(el=>el.hidden=false);const resetLimits=()=>entries.forEach(g=>g.limit=g.step);function render(){const words=normalize(search.value.trim()).split(/\s+/).filter(Boolean);let total=0;for(const group of entries){const selected=active==='all'||active===group.type;const matching=group.cards.filter(card=>words.every(word=>normalize(card.dataset.pbSearchtext||'').includes(word))&&(group.type!=='courts'||((city.value==='all'||card.dataset.pbCity===city.value)&&(access.value==='all'||card.dataset.pbAccess===access.value))));group.el.hidden=!selected;group.el.querySelector('.pb-grid').hidden=matching.length===0;group.cards.forEach(card=>card.hidden=true);if(selected){total+=matching.length;matching.slice(0,group.limit).forEach(card=>card.hidden=false)}if(group.more){const remain=matching.length-group.limit;group.more.hidden=!selected||remain<=0;group.more.textContent=root.dataset.moreLabel.replace('__COUNT__',String(Math.min(group.step,Math.max(0,remain)))).replace('__TOTAL__',String(matching.length));}group.el.hidden=!selected||(matching.length===0&&(group.type!=='courts'||active!=='courts'));}tabs.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pbFilter===active)));clear.hidden=!search.value&&active==='all'&&city.value==='all'&&access.value==='all';result.textContent=root.dataset.resultsLabel.replace('__COUNT__',String(total));empty.hidden=total!==0;}tabs.forEach(button=>button.addEventListener('click',()=>{active=button.dataset.pbFilter;city.value='all';access.value='all';resetLimits();render()}));search.addEventListener('input',()=>{resetLimits();render()});[city,access].forEach(select=>select.addEventListener('change',()=>{active='courts';resetLimits();render()}));clear.addEventListener('click',()=>{active='all';search.value='';city.value='all';access.value='all';resetLimits();render();search.focus()});entries.forEach(group=>{if(group.more)group.more.addEventListener('click',()=>{const first=group.cards.find(c=>c.hidden&&normalize(c.dataset.pbSearchtext||'').includes(normalize(search.value.trim())));group.limit+=group.step;render();if(first&&!first.hidden){const link=first.querySelector('a');if(link)link.focus({preventScroll:true})}})});root.querySelectorAll('[data-pb-jump]').forEach(link=>link.addEventListener('click',()=>{active=link.dataset.pbJump;search.value='';city.value='all';access.value='all';resetLimits();render()}));const dialog=root.querySelector('[data-pb-lightbox]'),photo=dialog.querySelector('[data-pb-full-image]'),caption=dialog.querySelector('[data-pb-full-caption]'),full=dialog.querySelector('[data-pb-full-link]');let opener=null;root.querySelectorAll('[data-pb-photo]').forEach(button=>button.addEventListener('click',()=>{opener=button;photo.src=button.dataset.pbPhoto;photo.alt=button.dataset.pbCaption;caption.textContent=button.dataset.pbCaption;full.href=button.dataset.pbPhoto;dialog.showModal()}));dialog.querySelector('[data-pb-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()}});dialog.addEventListener('close',()=>{if(opener)opener.focus({preventScroll:true})});render();};document.querySelectorAll('[data-pb-hub]').forEach(init);document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-pb-hub]').forEach(init)});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-product-atlas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('doi-product-atlas')) {
    class DoiProductAtlas extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.load();
      }
      disconnectedCallback() { this.abort?.abort(); this.started = false; }
      async load() {
        try {
          this.config = JSON.parse(this.querySelector('[data-connections]').textContent);
          this.abort = new AbortController();
          const config = this.config;
          let entries = config.entries.filter(Boolean);
          this.prepare(entries);
          this.render('related');
          this.querySelector('[data-fallback]').hidden = true;
          this.querySelector('.doi-connections__filters').hidden = false;
          this.querySelector('[data-status]').hidden = false;
          this.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => this.render(button.dataset.view), {signal: this.abort.signal}));
          for (let page = 1; page <= config.pages; page++) {
            if (page === config.page) continue;
            const url = new URL(window.location.href);
            url.searchParams.delete('section_id');
            url.searchParams.set('sections', this.dataset.section);
            url.searchParams.set(config.param, String(page));
            const response = await fetch(url, {signal: this.abort.signal});
            if (!response.ok) throw new Error('Unable to load connections');
            const sections = await response.json();
            const document = new DOMParser().parseFromString(sections[this.dataset.section] || '', 'text/html');
            const data = document.querySelector('[data-connections]');
            if (!data) throw new Error('Missing connections');
            entries = entries.concat(JSON.parse(data.textContent).entries.filter(Boolean));
          }
          if (config.pages > 1) { this.prepare(entries); this.render(this.view || 'related'); }
        } catch (error) {
          if (error.name === 'AbortError') return;
          console.warn('Atlas connections could not finish loading.', error);
          if (!this.entries?.length) this.querySelector('[data-fallback]').hidden = false;
        }
      }
      normalize(value) { return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
      terms(entry) {
        const stop = new Set('the and with from through into about valley coachella palm springs desert rancho mirage quinta indio indian wells california guide explore local regional story history places people community communities city landmark area life living map maps updates update views view outdoor destination destinations best new visit visiting scenic experience experiences of in at for to a an ca'.split(' '));
        return new Set(this.normalize([entry.name, entry.label, ...(entry.keywords || [])].join(' ')).split(' ').filter(term => term.length > 3 && !stop.has(term)));
      }
      topics(entry) {
        const text = this.normalize([entry.name, entry.label, ...(entry.keywords || [])].join(' '));
        const groups = [ /\b(arena|concerts?|hockey|basketball|theatre|theater|performing|festivals?|entertainment|music)\b/, /\b(rail|railroad|highway|freeway|airport|transportation|transit|traffic|corridor|roads?)\b/, /\b(mural|murals|sculpture|sculptures|artisan|public art|arts center)\b/, /\b(golf|golfing|golfer|fairways?|courses?)\b/, /\b(hiking|hikes?|trails?|trailheads?|mountains?|peaks?)\b/, /\b(geology|geological|faults?|badlands|sediment|sedimentary|tectonic|erosion|canyons?|ridges?)\b/, /\b(shopping|shops?|retailers?|retail|boutiques?|malls?)\b/, /\b(dining|restaurants?|food|culinary|cafes?)\b/, /\b(hotels?|resorts?|lodging|accommodation)\b/, /\b(birds?|birding|wildlife|migration|flyway|refuge)\b/, /\b(water|canal|aquifer|irrigation|chromium|drought)\b/, /\b(architecture|architect|architects|modernism|midcentury|preservation)\b/, /\b(pickleball|tennis|racquet|racquets)\b/, /\b(cahuilla|indigenous|tribal|tribe|tribes)\b/, /\b(dates|agriculture|agricultural|ranch|farming)\b/ ];
        return new Set(groups.flatMap((pattern, index) => pattern.test(text) ? [index] : []));
      }
      prepare(rawEntries) {
        const seen = new Set();
        const ranked = rawEntries.slice().sort((a,b) => Number(b.handle === this.config.canonical) - Number(a.handle === this.config.canonical));
        this.entries = ranked.filter(entry => {
          let url;
          try { url = new URL(entry.url, window.location.origin); } catch { return false; }
          if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return false;
          const key = url.pathname.replace(/\/$/, '');
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        this.current = this.entries.find(entry => entry.type === 'product' && entry.sourceId === this.config.productId);
        const current = this.current || {name:this.config.title, keywords:this.config.tags, locations:[]};
        const knownLocations = new Set(this.entries.flatMap(entry => entry.locations || []).filter(location => location !== 'Valley-wide'));
        const tags = [...this.config.tags, ...this.config.collections.filter(Boolean)].map(value => this.normalize(value));
        this.locations = (current.locations || []).filter(location => location !== 'Valley-wide');
        if (!this.locations.length) this.locations = [...knownLocations].filter(location => tags.includes(this.normalize(location)));
        const terms = this.terms(current), topics = this.topics(current);
        this.candidates = this.entries.filter(entry => !(entry.type === 'product' && entry.sourceId === this.config.productId)).map(entry => {
          const entryTerms = this.terms(entry), entryTopics = this.topics(entry);
          const biography = entry.category === 'People' && this.current?.category !== 'People';
          const unrelatedCommunity = entry.category === 'Communities' && this.current?.category !== 'Communities';
          const unrelatedDevelopment = /development/.test(this.normalize(entry.label)) && !/development/.test(this.normalize(current.label));
          const restricted = biography || unrelatedCommunity || unrelatedDevelopment;
          const overlap = restricted ? 0 : [...terms].filter(term => entryTerms.has(term)).length;
          const topicOverlap = restricted ? 0 : [...topics].filter(topic => entryTopics.has(topic)).length;
          const area = (entry.locations || []).some(location => this.locations.includes(location));
          const sameLabel = !!current.label && this.normalize(entry.label) === this.normalize(current.label);
          const selected = this.config.selected.indexOf(entry.handle);
          const category = this.current && entry.category === this.current.category;
          const score = (selected >= 0 ? 10000 - selected * 100 : 0) + (sameLabel ? 150 : 0) + topicOverlap * 60 + Math.min(overlap, 8) * 9 + (area ? 30 : 0) + (category ? 12 : 0);
          return {...entry, area, selected, score, subject:!restricted && (sameLabel || topicOverlap > 0 || overlap >= 2)};
        });
        this.querySelector('[data-view="area"]').hidden = !this.candidates.some(entry => entry.area);
      }
      compare(a,b) { return b.score - a.score || Number(a.order) - Number(b.order) || a.name.localeCompare(b.name); }
      broader() {
        const ordered = this.candidates.slice().sort((a,b) => {
          const aIndex = this.config.fallback.indexOf(a.handle), bIndex = this.config.fallback.indexOf(b.handle);
          return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex) || Number(b.featured) - Number(a.featured) || Number(a.order) - Number(b.order) || a.name.localeCompare(b.name);
        });
        const selected = [], categories = new Set();
        for (const entry of ordered) if (this.config.fallback.includes(entry.handle)) { selected.push(entry); categories.add(entry.category); }
        for (const entry of ordered) if (!categories.has(entry.category) && !selected.includes(entry)) {selected.push(entry);categories.add(entry.category);}
        return [...selected, ...ordered.filter(entry => !selected.includes(entry))];
      }
      render(view) {
        this.view = view;
        const text = this.config.text;
        let matches = [];
        if (view === 'area') matches = this.candidates.filter(entry => entry.area).sort((a,b) => this.compare(a,b));
        else if (view === 'valley') matches = this.broader();
        else matches = this.candidates.filter(entry => entry.selected >= 0 || entry.subject).sort((a,b) => this.compare(a,b));
        const count = matches.length;
        if (view === 'related' && matches.length === 0) {
          const handles = new Set(matches.map(entry => entry.handle));
          matches.push(...this.broader().filter(entry => !handles.has(entry.handle)).map(entry => ({...entry, broader:true})));
        }
        const cards = matches.slice(0,6);
        const grid = this.querySelector('[data-grid]');
        grid.replaceChildren(...cards.map(entry => this.card(entry, view)));
        this.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === view)));
        let status = text[view];
        if (view === 'area') status += ' ' + this.locations.join(' · ');
        if (view === 'related' && count === 0) status = text.fallback;
        if (!cards.length) status = text.empty;
        this.querySelector('[data-status]').textContent = status;
      }
      element(tag, className, text) {
        const element = document.createElement(tag);
        if (className) element.className = className;
        if (text) element.textContent = text;
        return element;
      }
      card(entry, view) {
        const text = this.config.text;
        const card = this.element('article','doi-connections__card');
        card.dataset.entry = entry.handle;
        const link = this.element('a'); link.href = entry.url;
        const media = this.element('div','doi-connections__media');
        if (entry.image) {
          const image = document.createElement('img');
          image.src = entry.image;
          image.srcset = `${entry.imageSmall} 450w, ${entry.image} 900w`;
          image.sizes = '(min-width: 1400px) 422px, (min-width: 990px) 31vw, (min-width: 600px) 46vw, 94vw';
          image.alt = ''; image.addEventListener('error', () => { image.remove(); media.prepend(this.element('span','doi-connections__placeholder',entry.name.slice(0,1))); }, {once:true}); image.loading = 'lazy'; image.decoding = 'async'; image.width = 900; image.height = 563;
          media.append(image);
        } else {
          const placeholder = this.element('span','doi-connections__placeholder',entry.name.slice(0,1));
          placeholder.setAttribute('aria-hidden','true');media.append(placeholder);
        }
        media.append(this.element('span','doi-connections__label',entry.label));
        const copy = this.element('div','doi-connections__copy');
        const reason = view === 'valley' || entry.broader ? text.broader : view === 'area' ? text.place : entry.selected >= 0 ? text.selected : entry.subject ? text.subject : text.place;
        copy.append(this.element('p','doi-connections__reason',reason),this.element('h3','doi-connections__title',entry.name),this.element('p','doi-connections__summary',entry.summary));
        const cta = this.element('span','doi-connections__card-cta',text.cta);
        cta.append(this.querySelector('.doi-connections__atlas-link svg').cloneNode(true));
        copy.append(cta);link.append(media,copy);card.append(link);return card;
      }
    }
    customElements.define('doi-product-atlas', DoiProductAtlas);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-rancho-mirage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-rancho-mirage')) {
  customElements.define('doi-rancho-mirage', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
      const cards = [...this.querySelectorAll('[data-rm-card]')];
      const filters = [...this.querySelectorAll('[data-rm-filter]')];
      const search = this.querySelector('[data-rm-search]');
      const more = this.querySelector('[data-rm-more]');
      const directoryState = window.DoiCityDirectoryState.read(this, filters.map(button => button.dataset.rmFilter));
      let active = directoryState.category || 'all';
      let limit = directoryState.limit || 16;
      search.value = directoryState.query || '';
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-rm-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-rm-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rmFilter === active)));
        window.DoiCityDirectoryState.write(this, { category: active, query: search.value, limit });
      };
      this.querySelector('[data-rm-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.rmFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-rm-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); if (more.hidden) cards.filter(card => !card.hidden).at(-1)?.querySelector('h3 a')?.focus(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-rm-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-rm-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-rm-map]');
          frame.src = 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=' + (option.value === 'overview' ? 13 : 16) + '&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-rm-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-rm-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-rm-directions]').href = 'https://www.google.com/maps/search/?api=1&query=' + encoded;
          window.DoiCityDirectoryState.write(this, { place: mapChoice.value });
        };
        on(mapChoice, 'change', updateMap);
        if (directoryState.place && [...mapChoice.options].some(option => option.value === directoryState.place)) { mapChoice.value = directoryState.place; updateMap(); }
        this.querySelectorAll('[data-rm-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.rmLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-rm-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-rm-day]')];
        const panels = [...this.querySelectorAll('[data-rm-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.rmPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rmDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.rmDay)));
        setDay('culture');
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-recommendations')) {
  customElements.define('doi-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, {rootMargin: '250px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async load() {
      try {
        const url = new URL(this.dataset.url, window.location.origin);
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) return;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('doi-recommendations [data-recommendation-content]');
        if (content) this.querySelector('[data-recommendation-content]').replaceChildren(...content.childNodes);
      } catch {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-restaurants"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-restaurants')) {
  customElements.define('doi-restaurants', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const location=window.DOIEmbeddedContext?.location||window.location,history=window.DOIEmbeddedContext?.history||window.history;
      const root = this, form = root.querySelector('form'), cards = [...root.querySelectorAll('[data-card]')];
      const ui = JSON.parse(root.querySelector('[data-ui]').textContent);
      const fieldNames = ['q','city','cuisine','meal','style','price','patio','saved','seasonal','day'];
      const normalFields=['cuisine','meal','style','price','patio','saved','seasonal'];
      let view='all';
      const general={title:root.querySelector('#rg-finder-title').textContent,kicker:root.querySelector('.rg-finder .rg-kicker').textContent,heading:root.querySelector('.rg-results-head h2').textContent,note:root.querySelector('.rg-result-note').textContent,filterNote:root.querySelector('.rg-finder>.rg-small').textContent};
      const today=()=>{const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());const p=Object.fromEntries(parts.map(x=>[x.type,x.value]));return {iso:`${p.year}-${p.month}-${p.day}`,day:new Date(`${p.year}-${p.month}-${p.day}T12:00:00Z`).getUTCDay()};};
      const selectedDay=()=>getField('day').value==='today'?today().day:Number(getField('day').value);
      const dayList=value=>(value||'').split(',').map(x=>x.trim()).filter(x=>/^[0-6]$/.test(x)).map(Number);
      function freshOffer(c){const offer=c.querySelector('[data-offer]');if(!offer)return null;const age=(Date.parse(today().iso+'T00:00:00Z')-Date.parse(offer.dataset.checked+'T00:00:00Z'))/86400000;return age>=0&&age<=30&&c.dataset.status==='listed'?offer:null;}
      function applyView(){
        root.dataset.view=view;root.querySelector('[data-rg-view]').value=view;
        normalFields.forEach(n=>getField(n).closest(n==='patio'||n==='saved'||n==='seasonal'?'.rg-toggles':'label').hidden=view==='happy');
        root.querySelector('[data-happy-control]').hidden=view!=='happy';
        root.querySelector('.rg-more-filters').hidden=view==='happy';
        root.querySelector('#rg-finder-title').textContent=view==='happy'?ui.hh_title:general.title;
        root.querySelector('.rg-finder .rg-kicker').textContent=view==='happy'?ui.hh_kicker:general.kicker;
        root.querySelector('.rg-finder>.rg-small').textContent=view==='happy'?ui.hh_filter_note:general.filterNote;
        root.querySelector('.rg-result-note').textContent=view==='happy'?ui.hh_note:general.note;
        const city=getField('city');[...city.options].forEach(o=>{o.hidden=view==='happy'&&o.value!==''&&!cards.some(c=>c.dataset.city===o.value&&freshOffer(c));});
        if(city.selectedOptions[0]?.hidden)city.value='';
      }
      root.querySelector('[data-rg-view]').addEventListener('change',event=>{root.dispatchEvent(new Event('doi:explorer-view-change'));view=event.target.value;message('');applyView();filter();});
      cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));
      cards.forEach(c=>root.querySelector('[data-grid]').append(c));
      let visibleLimit=18;
      root.querySelectorAll('[data-enhanced]').forEach(el => el.hidden=false);
      const connectPlaces=async()=>{try{
        const byKey=new Map((await window.DoiPlaces.load()).map(p=>[p.key,p]));
        for(const card of cards){const p=byKey.get(card.dataset.placeKey);if(!p)continue;
          card.dataset.name=p.name;card.querySelector('h3').textContent=p.name;card.querySelector('.rg-why').textContent=p.summary;
          if(p.mapEnabled && p.position){card.querySelectorAll('[data-restaurant-map]').forEach(a=>{const u=new URL('/pages/coachella-valley-interactive-map',location.origin);u.searchParams.set('layer','dining');u.hash='place='+encodeURIComponent(p.id);a.href=u.pathname+u.search+u.hash;});}
          if(!card.querySelector('[data-doi-guide]')){const guide=[...(p.resources||[]).map(r=>r.url),...(p.urls||[])].find(value=>{try{const u=new URL(value,location.origin);return u.origin===location.origin && /^\/products\//.test(u.pathname);}catch{return false;}});if(guide){const a=document.createElement('a');a.href=guide;a.dataset.doiGuide='';a.textContent='Explore on DOI';card.querySelector('.rg-card-links').append(a);}}

        }
        cards.sort((a,b)=>a.dataset.name.localeCompare(b.dataset.name));cards.forEach(c=>root.querySelector('[data-grid]').append(c));root.dataset.placeSource='shared';filter(false,false);
      }catch(error){root.dataset.placeSource='fallback';console.warn('Shared restaurant records:',error.message);}};
      if(window.DoiPlaces)connectPlaces();else window.addEventListener('doi:places-ready',connectPlaces,{once:true});
      root.querySelectorAll('[data-happy-link]').forEach(a=>{const u=new URL(a.href,location.origin);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);a.href=u.href;});
      root.addEventListener('click',e=>{const a=e.target.closest('[data-happy-link]');if(!a||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const card=a.closest('[data-card]');if(!card)return;const offer=freshOffer(card);if(!offer)return;e.preventDefault();view='happy';form.reset();getField('q').value=card.dataset.name;const days=dayList(offer.dataset.days);getField('day').value=days.includes(today().day)?'today':String(days[0]);applyView();filter(false);const u=new URL(a.href);u.searchParams.set('eat_day',getField('day').value);u.searchParams.set('eat_q',card.dataset.name);try{history.pushState(null,'',u);}catch{}const heading=card.querySelector('h3');heading.tabIndex=-1;card.scrollIntoView({block:'start'});heading.focus({preventScroll:true});});
      root.addEventListener('click',e=>{const a=e.target.closest('[data-restaurant-map],[data-map-browse]');if(!a)return;const u=new URL(a.href,location.origin),current=new URL(location.href);u.searchParams.set('from',current.pathname+current.search+current.hash);const preview=current.searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);a.href=u.href;});
      const message = text => root.querySelector('[data-message]').textContent = text;
      const norm = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'').toLowerCase();
      const getField = n => form.elements.namedItem(n);
      function readURL() {
        const p=new URL(location.href).searchParams;
        view=p.get('eat_view')==='happy'?'happy':'all';
        fieldNames.forEach(n => { const el=getField(n),v=p.get('eat_'+n)||(n==='day'?'today':''); if(el.type==='checkbox')el.checked=v==='1';else el.value=v; });
      }
      function updateURL() {
        const u=new URL(location.href);
        fieldNames.forEach(n => {const el=getField(n),v=el.type==='checkbox'?(el.checked?'1':''):el.value; if(v&&(n!=='day'||view==='happy')&&(view!=='happy'||n==='day'||n==='city'||n==='q'))u.searchParams.set('eat_'+n,v);else u.searchParams.delete('eat_'+n);});
        if(view==='happy')u.searchParams.set('eat_view','happy');else u.searchParams.delete('eat_view');
        try {history.replaceState(null,'',u);} catch {}
      }

      function filter(writeURL=true,resetLimit=true) {
        if(resetLimit)visibleLimit=18;
        const q=norm(getField('q').value.trim());let count=0;
        const day=selectedDay(),dayLabel=ui['hh_day_'+day];
        root.querySelector('.rg-results-head h2').textContent=view==='happy'?ui.hh_results_title.replace('{day}',dayLabel):general.heading;
        cards.forEach(c=>{const d=c.dataset;let visible=!q||norm([d.name,d.city,d.cuisine,c.querySelector('.rg-why').textContent].join(' ')).includes(q);
          (view==='happy'?['city']:['city','cuisine','style','price']).forEach(n=>{if(getField(n).value&&getField(n).value!==d[n])visible=false;});
          if(view!=='happy'&&getField('meal').value&&!d.meals.split('|').includes(getField('meal').value))visible=false;
          if(view!=='happy'&&getField('patio').checked&&d.patio!=='true')visible=false;
          if(view!=='happy'&&getField('saved').checked&&c.querySelector('[data-save]').getAttribute('aria-pressed')!=='true')visible=false;
          if(view!=='happy'&&getField('seasonal').checked&&d.status==='seasonal')visible=false;
          const offer=freshOffer(c);if(c.querySelector('[data-offer]'))c.querySelector('[data-offer]').hidden=view!=='happy'||!offer;const tag=c.querySelector('[data-happy-link]');if(tag)tag.hidden=!offer;
          if(view==='happy'){
            if(!offer||!dayList(offer.dataset.days).includes(day))visible=false;
            if(offer)offer.querySelector('[data-offer-hours]').textContent=dayList(offer.dataset.altDays).includes(day)&&offer.dataset.altHours?offer.dataset.altHours:offer.dataset.hours;
          }else if(offer)offer.querySelector('[data-offer-hours]').textContent=offer.dataset.schedule||offer.querySelector('[data-offer-hours]').dataset.fullSchedule;
          c.dataset.matches=String(visible);if(visible)count++;c.hidden=!visible||count>visibleLimit;
        });
        root.querySelector('[data-count]').textContent=(view==='happy'?(count===1?ui.compact_happy_single:ui.compact_happy):(count===1?ui.compact_result:ui.compact_results)).replace('{count}',count);
        root.querySelector('[data-empty] h3').textContent=view==='happy'?ui.hh_empty:ui.hh_normal_empty;
        root.querySelector('[data-empty] p').textContent=view==='happy'?ui.hh_empty_hint:ui.hh_normal_empty_hint;
        root.querySelector('[data-empty]').hidden=count>0;
        const more=root.querySelector('[data-load-more]');more.hidden=count<=visibleLimit;more.textContent=ui.load_more.replace('{next}',Math.min(18,Math.max(0,count-visibleLimit))).replace('{shown}',Math.min(visibleLimit,count)).replace('{count}',count);
        syncCompact();
        if(writeURL)updateURL();
      }
      function reset() {const active=document.activeElement;form.reset();applyView();message('');cards.forEach(c=>c.classList.remove('is-picked'));filter();if(active?.matches('[data-reset]')&&!active.getClientRects().length)getField('q').focus({preventScroll:true});}
      form.addEventListener('submit',e=>e.preventDefault());
      form.addEventListener('input',event=>{if(!fieldNames.includes(event.target.name))return;message('');filter();});
      root.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',reset));
      root.querySelectorAll('[data-preset]').forEach(b=>b.addEventListener('click',()=>{view='all';reset();const p=b.dataset.preset;if(p==='brunch')getField('meal').value='Brunch';if(p==='patio')getField('patio').checked=true;if(p==='date')getField('style').value='Date night';if(p==='casual')getField('style').value='Casual';filter();root.querySelector('#rg-finder').scrollIntoView({block:'start'});getField('city').focus({preventScroll:true});}));
      root.querySelector('[data-load-more]').addEventListener('click',()=>{const before=cards.filter(c=>!c.hidden).length;visibleLimit+=18;filter(false,false);const next=cards.filter(c=>c.dataset.matches==='true')[before];if(next)next.querySelector('[data-save]').focus({preventScroll:true});});
      root.querySelector('[data-surprise]').addEventListener('click',()=>{cards.forEach(c=>c.classList.remove('is-picked'));const choices=cards.filter(c=>c.dataset.matches==='true'&&c.dataset.status==='listed');if(!choices.length){message(ui.surprise_none);return;}const picked=choices[Math.floor(Math.random()*choices.length)];visibleLimit=Math.max(visibleLimit,cards.filter(c=>c.dataset.matches==='true').indexOf(picked)+1);filter(false,false);picked.classList.add('is-picked');picked.querySelector('details').open=true;root.dispatchEvent(new Event('doi:explorer-close-filters'));picked.scrollIntoView({block:'start'});picked.querySelector('summary').focus({preventScroll:true});});
      root.querySelector('[data-copy]').addEventListener('click',async()=>{const u=new URL(location.href);u.searchParams.delete('preview_theme_id');u.searchParams.delete('_ab');u.searchParams.delete('_fd');u.searchParams.delete('_sc');u.searchParams.delete('eat_saved');u.hash='rg-finder';try{await navigator.clipboard.writeText(u.href);message(ui.copied);}catch{message(ui.copy_failed+' '+u.href);}});
      window.addEventListener('popstate',()=>{readURL();applyView();filter(false);});
      document.addEventListener('mydoi:saves-updated',()=>{if(getField('saved').checked)filter(false,false);});
      cards.forEach(c=>{const o=c.querySelector('[data-offer]');if(o)o.querySelector('[data-offer-hours]').dataset.fullSchedule=o.querySelector('[data-offer-hours]').textContent;});
      function syncCompact(){
        const count=(getField('city').value?1:0)+(view==='happy'?0:normalFields.filter(n=>{const el=getField(n);return el.type==='checkbox'?el.checked:!!el.value;}).length);
        const badge=root.querySelector('[data-rg-filter-count]');badge.textContent=String(count);badge.hidden=!count;
        root.querySelector('[data-rg-filter-toggle]').setAttribute('aria-label',count?ui.active_filters.replace('{count}',count):ui.filters);
        root.querySelector('[data-rg-search-toggle]').dataset.active=String(!!getField('q').value.trim());
        const filtered=!!getField('q').value.trim()||!!getField('city').value||count>0||(view==='happy'&&getField('day').value!=='today');
        root.querySelector('.rg-filter-footer [data-reset]').hidden=!filtered;
      }
      readURL();applyView();filter(false);
      root.dataset.explorerReady='true';
      root.dispatchEvent(new CustomEvent('doi:explorer-ready',{bubbles:true}));
      let lastDate=today().iso;
      this.hhTimer=setInterval(()=>{if(!root.isConnected){clearInterval(this.hhTimer);return;}const date=today().iso;if(date!==lastDate){lastDate=date;applyView();filter(false,false);}},60000);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-salton-sea"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('doi-salton-sea')) {
  customElements.define('doi-salton-sea', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const on = (element, type, handler) => element?.addEventListener(type, handler, { signal });
const library=this.querySelector('[data-ssh-library]');
if(library){
 const grid=library.querySelector('[data-ssh-grid]'),search=library.querySelector('[data-ssh-search]'),filters=[...library.querySelectorAll('[data-ssh-filter]')],more=library.querySelector('[data-ssh-more]'),empty=library.querySelector('[data-ssh-empty]'),note=library.querySelector('[data-ssh-feed-note]');
 const normalize=value=>String(value||'').normalize('NFKD').replace(/\p{M}/gu,'').toLowerCase();
 let cards=[...grid.querySelectorAll('[data-ssh-card]')],active='all',limit=9,loading=false;
 const labels=Object.fromEntries(filters.map(b=>[b.dataset.sshFilter,b.querySelector('span').textContent]));
 const apply=()=>{const words=normalize(search.value).trim().split(/\s+/).filter(Boolean);const matches=cards.filter(card=>(active==='all'||card.dataset.group===active)&&words.every(word=>normalize(card.dataset.search).includes(word)));cards.forEach(c=>c.hidden=true);matches.slice(0,limit).forEach(c=>c.hidden=false);library.querySelector('[data-ssh-count]').textContent=library.dataset.countPattern.replace('__COUNT__',Math.min(limit,matches.length)).replace('__TOTAL__',matches.length);empty.hidden=!!matches.length;more.hidden=matches.length<=limit;more.textContent=library.dataset.morePattern.replace('__COUNT__',Math.min(9,Math.max(0,matches.length-limit)));filters.forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.sshFilter===active));b.querySelector('[data-ssh-group-count]').textContent=b.dataset.sshFilter==='all'?cards.length:cards.filter(c=>c.dataset.group===b.dataset.sshFilter).length;});};
 library.querySelector('[data-ssh-controls]').hidden=false;
 filters.forEach(b=>on(b,'click',()=>{active=b.dataset.sshFilter;limit=9;apply();}));on(search,'input',()=>{limit=9;apply();});on(more,'click',()=>{limit+=9;apply();});on(library.querySelector('[data-ssh-reset]'),'click',()=>{active='all';search.value='';limit=9;apply();search.focus();});apply();
 const groupFor=item=>{const text=normalize(item.title+' '+String(item.tags||''));if(/boat rac|hydroplane|hurricane iv|cream puff|desert kid/.test(text))return'racing';if(/bird|wildlife|fish|flyway|egret|crane/.test(text)&&!/restor|salv|knight/.test(text))return'wildlife';if(/water|restor|shrinking|salinity|odor|air quality|geothermal|lithium|agricultur/.test(text))return'water';if(/day trip|winter|photograph|from above/.test(text))return'visit';return'history';};
 const loadLatest=async()=>{if(loading)return;loading=true;note.hidden=true;try{const items=[];let current=1,pages=1;do{const u=new URL('/search',location.origin);u.searchParams.set('q','Salton Sea');u.searchParams.set('type','article');u.searchParams.set('view','doi-profiles');u.searchParams.set('options[prefix]','last');u.searchParams.set('page',current);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);const res=await fetch(u,{signal:AbortSignal.timeout(12000),headers:{Accept:'application/json'}});if(!res.ok)throw Error('Unavailable');const data=await res.json();if(data.version!==1||!Array.isArray(data.items)||data.page!==current||!Number.isInteger(data.pages)||data.pages<1||data.pages>20)throw Error('Invalid article feed');items.push(...data.items);pages=data.pages;current++;}while(current<=pages);
 const known=new Set(cards.map(c=>c.dataset.storyUrl));let added=0;
 for(const item of items){const tags=Array.isArray(item.tags)?item.tags:String(item.tags||'').split(',');if(item.kind!=='article'||!tags.some(t=>normalize(t).trim()==='salton sea'))continue;const url=new URL(item.url,location.origin);if(url.origin!==location.origin||!url.pathname.startsWith('/blogs/')||known.has(url.pathname)||!item.title)continue;const card=cards[0]?.cloneNode(true);if(!card)continue;card.removeAttribute('data-shopify-editor-block');card.dataset.storyUrl=url.pathname;card.dataset.group=groupFor(item);card.dataset.search=[item.title,item.tags,item.summary].join(' ');card.querySelector('[data-ssh-title]').textContent=item.title;card.querySelector('[data-ssh-topic]').textContent=labels[card.dataset.group];card.querySelector('[data-ssh-summary]').textContent=String(item.summary||'').replace(/<[^>]*>/g,'').slice(0,155);card.querySelectorAll('a').forEach(a=>a.href=url.pathname);const photo=card.querySelector('.ss-story-photo');photo.replaceChildren();if(item.image){const src=new URL(item.image,location.origin);if(src.protocol==='https:'&&(src.origin===location.origin||src.hostname==='cdn.shopify.com')){const img=document.createElement('img');img.src=src.href;img.alt='';img.loading='lazy';img.width=900;img.height=506;photo.append(img);}}grid.prepend(card);known.add(url.pathname);added++;}
 if(!this.isConnected)return;cards=[...grid.querySelectorAll('[data-ssh-card]')];apply();library.dataset.feed='ready';library.dataset.added=String(added);
 }catch(e){if(this.isConnected){note.hidden=false;library.dataset.feed='fallback';}}finally{loading=false;}};
 on(library.querySelector('[data-ssh-retry]'),'click',loadLatest);loadLatest();
}

      const cards = [...this.querySelectorAll('[data-ss-card]')];
      const filters = [...this.querySelectorAll('[data-ss-filter]')];
      const search = this.querySelector('[data-ss-search]');
      const more = this.querySelector('[data-ss-more]');
      let active = 'all';
      let limit = 16;
      const applyFilters = () => {
        const query = search.value.trim().toLocaleLowerCase();
        const matches = cards.filter(card => (active === 'all' || card.dataset.group === active) && card.dataset.search.toLocaleLowerCase().includes(query));
        cards.forEach(card => { card.hidden = true; });
        matches.slice(0, limit).forEach(card => { card.hidden = false; });
        const shown = Math.min(limit, matches.length);
        this.querySelector('[data-ss-count]').textContent = this.dataset.countPattern.replace('__COUNT__', shown).replace('__TOTAL__', matches.length);
        this.querySelector('[data-ss-empty]').hidden = matches.length > 0;
        more.hidden = matches.length <= limit;
        more.textContent = this.dataset.morePattern.replace('__COUNT__', Math.min(16, Math.max(0, matches.length - shown))).replace('__TOTAL__', matches.length);
        filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ssFilter === active)));
      };
      this.querySelector('[data-ss-controls]').hidden = false;
      filters.forEach(button => on(button, 'click', () => { active = button.dataset.ssFilter; limit = 16; if (document.startViewTransition && !matchMedia('(prefers-reduced-motion: reduce)').matches) { document.startViewTransition(applyFilters); } else { applyFilters(); } }));
      on(search, 'input', () => { limit = 16; applyFilters(); });
      on(this.querySelector('[data-ss-reset]'), 'click', () => { active = 'all'; search.value = ''; limit = 16; applyFilters(); search.focus(); });
      on(more, 'click', () => { limit += 16; applyFilters(); });
      applyFilters();
      const mapChoice = this.querySelector('[data-ss-map-choice]');
      if (mapChoice) {
        this.querySelector('[data-ss-map-controls]').hidden = false;
        const updateMap = () => {
          const option = mapChoice.selectedOptions[0];
          const encoded = encodeURIComponent(option.dataset.query);
          const frame = this.querySelector('[data-ss-map]');
          frame.src = option.dataset.overviewSrc ? option.dataset.overviewSrc : 'https://maps.google.com/maps?q=' + encoded + '&t=h&z=16&output=embed';
          frame.title = option.textContent.trim();
          this.querySelector('[data-ss-map-status]').textContent = option.textContent.trim();
          this.querySelector('[data-ss-access-note]').textContent = option.dataset.accessNote;
          this.querySelector('[data-ss-directions]').href = option.dataset.overviewLink ? option.dataset.overviewLink : 'https://www.google.com/maps/search/?api=1&query=' + encoded;
        };
        on(mapChoice, 'change', updateMap);
        this.querySelectorAll('[data-ss-locate]').forEach(button => {
          button.hidden = false;
          on(button, 'click', () => {
            mapChoice.value = button.dataset.ssLocate;
            updateMap();
            mapChoice.closest('section').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            mapChoice.focus({ preventScroll: true });
          });
        });
      }
      const dayControls = this.querySelector('[data-ss-day-controls]');
      if (dayControls) {
        dayControls.hidden = false;
        const choices = [...this.querySelectorAll('[data-ss-day]')];
        const panels = [...this.querySelectorAll('[data-ss-plan]')];
        const setDay = value => {
          panels.forEach(panel => { panel.hidden = panel.dataset.ssPlan !== value; });
          choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ssDay === value)));
        };
        choices.forEach(button => on(button, 'click', () => setDay(button.dataset.ssDay)));
        if (choices.length) setDay(choices[0].dataset.ssDay);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-tlq-hub"] && !Shopify.designMode) return;
  try {
    
function initializeTlqHubs(root) {
  root.querySelectorAll('[data-tlqh]').forEach(hub => {
    if (hub.dataset.ready) return;
    hub.dataset.ready = 'true';
    hub.querySelectorAll('[data-video-id]').forEach(play => play.addEventListener('click', () => {
      const id = play.dataset.videoId;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id)) return;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = play.getAttribute('aria-label');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      play.replaceWith(frame);
      frame.setAttribute('tabindex', '0');
      frame.focus();
    }));
    const track = hub.querySelector('.tlqh__track');
    const controls = hub.querySelector('.tlqh__controls');
    if (!track || !controls) return;
    controls.hidden = false;
    const buttons = controls.querySelectorAll('button');
    const update = () => {
      buttons[0].disabled = track.scrollLeft <= 2;
      buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    buttons.forEach(button => button.addEventListener('click', () => {
      const card = track.querySelector('li');
      const distance = card ? card.getBoundingClientRect().width + 22 : track.clientWidth;
      track.scrollBy({left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    track.addEventListener('scroll', update, {passive:true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initializeTlqHubs(document);
document.addEventListener('shopify:section:load', event => initializeTlqHubs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-weekly"] && !Shopify.designMode) return;
  try {
    
function initializeWeekly(root) {
  if (root.dataset.weeklyReady) return;
  root.dataset.weeklyReady = 'true';
  const stories = [...root.querySelectorAll('[data-weekly-story]')];
  const filters = [...root.querySelectorAll('[data-weekly-filter]')];
  const city = root.querySelector('[data-weekly-city]');
  const count = root.querySelector('[data-weekly-count]');
  const empty = root.querySelector('[data-weekly-empty]');
  let topic = 'all';
  function filter() {
    let shown = 0;
    stories.forEach(story => {
      const visible = (topic === 'all' || story.dataset.topic === topic) && (city.value === 'all' || story.dataset.city === city.value);
      story.hidden = !visible;
      if (visible) shown += 1;
    });
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.weeklyFilter === topic)));
    count.textContent = `${shown} / ${stories.length} ${count.dataset.suffix}`;
    empty.hidden = shown !== 0;
  }
  root.querySelector('[data-weekly-filters]').hidden = false;
  count.hidden = false;
  filters.forEach(button => button.addEventListener('click', () => { topic = button.dataset.weeklyFilter; filter(); }));
  city.addEventListener('change', filter);
  root.querySelector('[data-weekly-reset]').addEventListener('click', () => { topic = 'all'; city.value = 'all'; filter(); filters[0].focus(); });
  filter();
  const dialog = root.querySelector('[data-weekly-dialog]');
  let origin;
  root.querySelectorAll('[data-weekly-photo]').forEach(link => link.addEventListener('click', event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || !dialog.showModal) return;
    event.preventDefault(); origin = link;
    const image = dialog.querySelector('img');
    image.src = link.href + '&width=2000'; image.alt = link.dataset.photoAlt;
    dialog.querySelector('figcaption').textContent = link.dataset.photoCaption;
    dialog.showModal(); document.documentElement.style.overflow = 'hidden';
  }));
  root.querySelector('[data-weekly-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; origin?.focus(); });
  root.querySelector('[data-weekly-share]').addEventListener('click', async () => {
    const status = root.querySelector('[data-share-status]');
    try { const url = new URL(location.href); if (!url.searchParams.has('preview_theme_id')) { url.search = ''; url.hash = ''; } await navigator.clipboard.writeText(url.href); status.textContent = status.dataset.copied; const button = root.querySelector('[data-weekly-share]'); const original = button.textContent; button.textContent = status.dataset.copied; setTimeout(() => { button.textContent = original; }, 2500); }
    catch { status.textContent = status.dataset.failed; }
  });
}
document.querySelectorAll('[data-weekly-edition]').forEach(initializeWeekly);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-weekly-edition]').forEach(initializeWeekly));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-wildlife-profile"]) return;
  try {
    
(() => {
  const start = (scope = document) => {
    scope.querySelectorAll('[data-wildlife-profile]').forEach((root) => {
      if (root.dataset.wpReady) return;
      root.dataset.wpReady = 'true';
      root.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        history.replaceState(history.state, '', link.hash);
      }, true);
      const behaviorButtons = [...root.querySelectorAll('[data-wp-behavior]')];
      const behaviorPanels = [...root.querySelectorAll('[data-wp-behavior-panel]')];
      if (behaviorButtons.length) {
        const chooseBehavior = (value) => {
          behaviorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.wpBehavior === value)));
          behaviorPanels.forEach(panel => { panel.hidden = panel.dataset.wpBehaviorPanel !== value; });
        };
        behaviorButtons.forEach(button => button.addEventListener('click', () => chooseBehavior(button.dataset.wpBehavior)));
        chooseBehavior('1');
        root.querySelector('[data-wp-behavior-buttons]').hidden = false;
      }
      const photos = [...root.querySelectorAll('[data-wp-photo]')];
      const cards = [...root.querySelectorAll('[data-wp-gallery-card]')];
      const more = root.querySelector('[data-wp-more]');
      const dialog = root.querySelector('[data-wp-dialog]');
      let visible = 15;
      const showCards = () => {
        cards.forEach((card, i) => { card.hidden = i >= visible; });
        if (more) {
          more.hidden = visible >= cards.length;
          more.textContent = more.dataset.wpMoreTemplate.replace('__COUNT__', Math.min(16, Math.max(0,cards.length-visible))).replace('__TOTAL__',photos.length);
        }
      };
      showCards();
      if (more) more.addEventListener('click', () => {
        const firstNew = cards[visible];
        visible += 16;
        showCards();
        if (firstNew) firstNew.querySelector('a').focus({preventScroll: true});
      });
      if (!dialog || !photos.length || typeof dialog.showModal !== 'function') return;
      const fullImage = dialog.querySelector('[data-wp-full-image]');
      const caption = dialog.querySelector('[data-wp-caption]');
      const count = dialog.querySelector('[data-wp-count]');
      const prev = dialog.querySelector('[data-wp-prev]');
      const next = dialog.querySelector('[data-wp-next]');
      let current = 0;
      let opener;
      let oldOverflow = '';
      let startX = 0;
      let startY = 0;
      const show = (index) => {
        current = (index + photos.length) % photos.length;
        const photo = photos[current];
        const thumbnail = photo.querySelector('img');
        fullImage.src = photo.href;
        fullImage.alt = thumbnail ? thumbnail.alt : '';
        fullImage.width = thumbnail?.naturalWidth || 1800;
        fullImage.height = thumbnail?.naturalHeight || 1200;
        caption.textContent = photo.dataset.caption || fullImage.alt;
        count.textContent = `${current + 1} / ${photos.length}`;
        prev.hidden = next.hidden = photos.length < 2;
      };
      const open = (index, trigger) => {
        opener = trigger;
        show(index);
        if (!dialog.open) {
          oldOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          dialog.querySelector('[data-wp-close]').focus();
        }
      };
      photos.forEach((photo, i) => photo.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(i, photo);
      }));
      root.querySelectorAll('[data-wp-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
        event.preventDefault();
        open(0, trigger);
      }));
      dialog.querySelector('[data-wp-close]').addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      dialog.addEventListener('close', () => {
        document.body.style.overflow = oldOverflow;
        fullImage.removeAttribute('src');
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      fullImage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, {passive: true});
      fullImage.addEventListener('touchend', (event) => {
        if (!event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx > 0 ? -1 : 1));
      }, {passive: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doi-zoo-profile"]) return;
  try {
    
(() => {
  const start = (scope = document) => {
    scope.querySelectorAll('[data-zoo-profile]').forEach((root) => {
      if (root.dataset.zpReady) return;
      root.dataset.zpReady = 'true';
      root.addEventListener('click', (event) => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        history.replaceState(history.state, '', link.hash);
      }, true);
      const photos = [...root.querySelectorAll('[data-zp-photo]')];
      const cards = [...root.querySelectorAll('[data-zp-gallery-card]')];
      const more = root.querySelector('[data-zp-more]');
      const dialog = root.querySelector('[data-zp-dialog]');
      let visible = 15;
      const showCards = () => {
        cards.forEach((card, i) => { card.hidden = i >= visible; });
        if (more) {
          more.hidden = visible >= cards.length;
          more.textContent = more.dataset.zpMoreTemplate.replace('__COUNT__', Math.min(16, Math.max(0,cards.length-visible))).replace('__TOTAL__',photos.length);
        }
      };
      showCards();
      if (more) more.addEventListener('click', () => {
        const firstNew = cards[visible];
        visible += 16;
        showCards();
        if (firstNew) firstNew.querySelector('a').focus({preventScroll: true});
      });
      if (!dialog || !photos.length || typeof dialog.showModal !== 'function') return;
      const fullImage = dialog.querySelector('[data-zp-full-image]');
      const caption = dialog.querySelector('[data-zp-caption]');
      const count = dialog.querySelector('[data-zp-count]');
      const prev = dialog.querySelector('[data-zp-prev]');
      const next = dialog.querySelector('[data-zp-next]');
      let current = 0;
      let opener;
      let oldOverflow = '';
      let startX = 0;
      let startY = 0;
      const show = (index) => {
        current = (index + photos.length) % photos.length;
        const photo = photos[current];
        const thumbnail = photo.querySelector('img');
        fullImage.src = photo.href;
        fullImage.alt = thumbnail ? thumbnail.alt : '';
        fullImage.width = thumbnail?.naturalWidth || 1800;
        fullImage.height = thumbnail?.naturalHeight || 1200;
        caption.textContent = photo.dataset.caption || fullImage.alt;
        count.textContent = `${current + 1} / ${photos.length}`;
        prev.hidden = next.hidden = photos.length < 2;
      };
      const open = (index, trigger) => {
        opener = trigger;
        show(index);
        if (!dialog.open) {
          oldOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          dialog.querySelector('[data-zp-close]').focus();
        }
      };
      photos.forEach((photo, i) => photo.addEventListener('click', (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        open(i, photo);
      }));
      root.querySelectorAll('[data-zp-open]').forEach((trigger) => trigger.addEventListener('click', (event) => {
        event.preventDefault();
        open(0, trigger);
      }));
      dialog.querySelector('[data-zp-close]').addEventListener('click', () => dialog.close());
      prev.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      dialog.addEventListener('close', () => {
        document.body.style.overflow = oldOverflow;
        fullImage.removeAttribute('src');
        if (opener && opener.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      fullImage.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, {passive: true});
      fullImage.addEventListener('touchend', (event) => {
        if (!event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) show(current + (dx > 0 ? -1 : 1));
      }, {passive: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(), {once: true});
  else start();
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
